import {Mapper} from '@s-ui/domain'

export class FromVehicleSearchJSONtoUrlVOMapper extends Mapper {
  constructor({config}) {
    super({config})
    this._config = config
    this._bodyTypeCategoryId = this._config.get('search').BODY_TYPE_CATEGORY
    this._defaultSortBy = this._config.get('SORT_FIELDS').RELEVANCE
    this._defaultSortOrder = this._config.get('ORDER').DESC
  }

  /**
   * If value is 0 param should not exist, then it shouldn't appear on the URL
   */
  _avoidDefaultValue = value => value || undefined

  /**
   * Avoid 0 values in URL
   * Array should appear as "pipe" separated strings in URL
   */
  _parseArrayFilter = (array = []) => (array.filter(Boolean).length > 0 ? array.join('|') : undefined)

  setParams = ({
    page,
    sortBy = this._defaultSortBy,
    sortOrder = this._defaultSortOrder,
    makeId,
    model = {},
    modelVersionId,
    fuelTypeIds = [],
    bodyTypeIds = [],
    category2Id = 0,
    price = {},
    litres = {},
    year = {},
    kms = {},
    version,
    doors = [],
    hp = {}
  }) => {
    this._page = page
    this._sortBy = sortBy
    this._sortOrder = sortOrder
    this._makeId = makeId
    this._model = model
    this._modelVersionId = modelVersionId
    this._fuelTypeIds = fuelTypeIds
    this._bodyTypeIds = bodyTypeIds
    this._category2Id = category2Id
    this._price = price
    this._litres = litres
    this._year = year
    this._kms = kms
    this._version = version
    this._doors = doors
    this._hp = hp

    return this
  }

  map = () => ({
    pg: this._page,
    fi: this._sortBy,
    or: this.getSortDirection(),
    MakeId: this.getMakeId(),
    Model: this._avoidDefaultValue(this._model.label),
    ModelId: this._avoidDefaultValue(this._model.id),
    ModelVersionId: this._avoidDefaultValue(this._modelVersionId),
    FuelTypeId: this._parseArrayFilter(this._fuelTypeIds),
    BodyTypeId: this._avoidDefaultValue(this.getBodyType()),
    MinPrice: this._avoidDefaultValue(this._price.from),
    MaxPrice: this._avoidDefaultValue(this._price.to),
    MinLitres: this._avoidDefaultValue(this._litres.from),
    MaxLitres: this._avoidDefaultValue(this._litres.to),
    MinKms: this._avoidDefaultValue(this._kms.from),
    MaxKms: this._avoidDefaultValue(this._kms.to),
    MinYear: this._avoidDefaultValue(this._year.from),
    MaxYear: this._avoidDefaultValue(this._year.to),
    Doors: this._parseArrayFilter(this._doors),
    MinHp: this._avoidDefaultValue(this._hp.from),
    MaxHp: this._avoidDefaultValue(this._hp.to),
    Section2: this._avoidDefaultValue(this._category2Id),
    Version: this._version || undefined
  })

  getSortDirection = () => (this._sortOrder === this._defaultSortOrder ? -1 : 1)

  // The visual separators have value = -1. That's why we check makeId > 0
  getMakeId = () => (this._makeId > 0 ? this._makeId : undefined)

  getBodyType = () => (!this.hasBodyTypeCategoryBeenSelected(this._bodyTypeIds) ? this._bodyTypeIds[0] : undefined)

  /*
   ********** Details Implementation alert.
   * In the UI, the bodyTypeIds are shown as a dropdown which are grouped by a category.
   * These categories are: MOTORCYCLE, SCOOTER, ROAD and OFFROAD.
   * The user can select them too. In that case, the name of the query param is
   * Section2 instead of bodyTypeIds
   */
  hasBodyTypeCategoryBeenSelected = () =>
    this._bodyTypeIds.includes(this._bodyTypeCategoryId.MOTORCYCLE) ||
    this._bodyTypeIds.includes(this._bodyTypeCategoryId.SCOOTER) ||
    this._bodyTypeIds.includes(this._bodyTypeCategoryId.ROAD) ||
    this._bodyTypeIds.includes(this._bodyTypeCategoryId.OFFROAD)
}
